import { getWebApiBaseUrl } from '../config/apiBaseUrl';
import { getViewerDeviceId } from '../viewerDeviceId';

const SKIP_PREFIXES = ['/admin'];
const DEDUPE_MS = 15000;

let lastTrackedPath = '';
let lastTrackedAt = 0;

export function routeLabelForPath(pathname: string): string {
  if (pathname === '/') return 'Home';
  if (pathname === '/search') return 'Search';
  if (pathname === '/sell') return 'Sell';
  if (pathname === '/sell-app') return 'Sell app download';
  if (pathname === '/app') return 'Buyer app download';
  if (pathname === '/cart') return 'Cart';
  if (pathname === '/checkout') return 'Checkout';
  if (pathname === '/login') return 'Log in';
  if (pathname === '/register') return 'Sign up';
  if (pathname === '/my-orders') return 'My orders';
  if (pathname === '/followed') return 'Followed';
  if (pathname === '/help') return 'Help center';
  if (pathname === '/survey' || pathname === '/survay') return 'Survey';
  if (pathname.startsWith('/listings/')) return 'Listing';
  if (pathname.startsWith('/stores/')) return 'Store';
  if (pathname.startsWith('/sellers/')) return 'Seller';
  if (pathname.startsWith('/orders/')) return 'Order confirmation';
  if (pathname.startsWith('/track/')) return 'Track order';
  if (pathname.startsWith('/messages')) return 'Messages';
  if (pathname === '/terms') return 'Terms';
  if (pathname === '/privacy') return 'Privacy';
  if (pathname === '/cookies') return 'Cookie policy';
  return pathname;
}

export function shouldTrackPageVisit(pathname: string): boolean {
  if (!pathname || !pathname.startsWith('/')) return false;
  return !SKIP_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

function sendPageVisit(pathname: string, search: string): void {
  const viewerDeviceId = getViewerDeviceId();
  if (!viewerDeviceId) return;

  const path = `${pathname}${search || ''}`.slice(0, 512);
  const payload = {
    path,
    route_label: routeLabelForPath(pathname),
    viewer_device_id: viewerDeviceId,
    platform: 'web',
    referrer: typeof document !== 'undefined' ? document.referrer || undefined : undefined,
  };

  const url = `${getWebApiBaseUrl()}/analytics/page-view`;
  const body = JSON.stringify(payload);

  if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    const blob = new Blob([body], { type: 'application/json' });
    if (navigator.sendBeacon(url, blob)) return;
  }

  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
    credentials: 'include',
  }).catch(() => {
    /* fire and forget */
  });
}

export function recordPageVisit(pathname: string, search = ''): void {
  if (!shouldTrackPageVisit(pathname)) return;

  const path = `${pathname}${search || ''}`;
  const now = Date.now();
  if (path === lastTrackedPath && now - lastTrackedAt < DEDUPE_MS) return;
  lastTrackedPath = path;
  lastTrackedAt = now;

  const run = () => sendPageVisit(pathname, search);
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(run, { timeout: 2000 });
  } else {
    setTimeout(run, 0);
  }
}
